export const appidClient = 'joybuyPC';
export const appidServer = 'joybuyPC_Server';

export const jsSecurityFunctionIdList = [
  'guide_search_getDefaultWord',
  'user_help_getQuestionList',
  'trade_item_get',
  'trade_item_getLite',
  'trade_item_getDescription',
  'trade_payment_getPayResult',
  'trade_payment_getPayMethods',
  'trade_payment_pay',
  'trade_payment_validate',
  'user_address_add',
  'user_address_getList',
  'user_account_get',
  'user_coupon_getList',
  'guide_homepage_getPageAllData',
  'guide_homepage_getItemFeeds',
  'guide_homepage_getCoupon',
  'guide_catalog_getRootCates',
  'trade_cart_get',
  'trade_cart_modifyItem',
  'trade_cart_addItem',
  'trade_checkout_get',
  'trade_checkout_getCoupons',
  'trade_checkout_changeAddress',
  'trade_checkout_submit',
  'trade_order_getList',
  'trade_order_get',
  'user_account_verifyAccountExist',
  'user_account_getLoginInfo',
  'user_account_getLoginTypes',
  'guide_search_getItems',
  'guide_recommendation_get',
  'guide_search_getSuggestWords',
  'guide_search_getHotWords',
  'marketing_interact_getActivityDetail',
  'marketing_interact_getInteractActivity',
  'user_account_regOrLoginByPwd',
  'user_account_loginByOuterAuth',
  'user_account_loginByVerifyCode',
  'user_account_sendVerifyCode',
  'user_account_checkVerifyCode',
  'user_account_verifyAccount',
  'content_review_getItem',
  'user_account_modifyUserInfo',
];
